<div class="page-inner-body portlet light px-3">
  <div class="portlet-body">
    <!-- Invitation section -->
    <div class="row pt-3">
      <div class="col-12 g-0 d-flex justify-content-between align-items-center">
        <!-- Invitation header -->
        <div class="p-toolbar-group-start" style="font-size: x-large;">{{ 'connectionRequest.artflowInvitation' | transloco }}</div>
        <!-- Accept/Reject buttons -->
        <div class="p-toolbar-group-end">
          <div class="d-flex flex-column">
            <span class="fw-bold mb-2 ">{{ 'connectionRequest.acceptInvitation' | transloco }}</span>
            <div class="d-flex justify-content-end">
              <p-button type="button" [label]="'connectionRequest.confirm' | transloco" icon="fa fa-check-circle" [outlined]="true"
              (click)="confirmInviteDialog()"></p-button>
              <p-button type="button" [label]="'connectionRequest.ignore' | transloco" icon="fa fa-times" [outlined]="true"
              severity="danger" class=" ms-1" (click)="rejectInvitationDialog()"></p-button>
            </div>
          </div>
        </div>
      </div>
      <div class="table-toolbar">
        <div class="row text-bg-light mt-2 border">
          <div class="col-md-12">
            @if (connectionData) {
              <div class="d-flex justify-content-between align-items-center p-2">
                <div class="d-flex justify-content-start align-items-center">
                  <!-- Sender Image -->
                  <img [src]="connectionData.SenderImageUrl ? connectionData.SenderImageUrl : 'assets/images/No-Image.png'"
                    class="rounded-circle me-2 cursor-pointer" height="32" />
                    <div>
                      <!-- Sender Name -->
                      <span class="fs-4 text-uppercase cursor-pointer">{{ connectionData.SenderName
                      }}</span>
                      <!-- Connection Request Status -->
                      <span class="fs-5 small"> {{ 'connectionRequest.viewingConnectionRequest' | transloco }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

      </div>

      <div class="row border py-3">
        <div class="col-12 mb-2">
          <div class="social-links">
            <!-- Social Media Links -->
            @if (connectionData) {
              @if (connectionData.SenderFacebookLink) {
                <a [href]="connectionData.SenderFacebookLink"
                  target="_blank" class="icon-link me-2">
                  <i class="fa fa-facebook-official text-muted"></i>
                </a>
              }
              @if (connectionData.SenderInstagramLink) {
                <a [href]="connectionData.SenderInstagramLink"
                  target="_blank" class="icon-link me-2">
                  <i class="fa fa-instagram text-muted"></i>
                </a>
              }
              @if (connectionData.SenderLinkedinLink) {
                <a [href]="connectionData.SenderLinkedinLink"
                  target="_blank" class="icon-link me-2">
                  <i class="fa fa-linkedin-square text-muted"></i>
                </a>
              }
              @if (connectionData.SenderWebsite) {
                <a [href]="connectionData.SenderWebsite" target="_blank"
                  class="icon-link me-2">
                  <i class="fa fa-globe text-muted"></i>
                </a>
              }
              @if (connectionData.SenderBusinessFacebookLink) {
                <a
                  [href]="connectionData.SenderBusinessFacebookLink" target="_blank" class="icon-link me-2">
                  <i class="fa fa-facebook-official text-muted"></i>
                </a>
              }
              @if (connectionData.SenderBusinessInstagramLink) {
                <a
                  [href]="connectionData.SenderBusinessInstagramLink" target="_blank" class="icon-link me-2">
                  <i class="fa fa-instagram text-muted"></i>
                </a>
              }
              @if (connectionData.SenderBusinessLinkedinLink) {
                <a
                  [href]="connectionData.SenderBusinessLinkedinLink" target="_blank" class="icon-link me-2">
                  <i class="fa fa-linkedin-square text-muted"></i>
                </a>
              }
            }
            <div class="row">
              <!-- Sender Email -->
              @if (connectionData.SenderEmail) {
                <div class=" mb-1">
                  <i class="fa fa-envelope text-muted"></i>
                  <span class="ms-1  fw-bold">{{ 'connectionRequest.email' | transloco }}</span>
                  <span class="ms-1">{{ connectionData.SenderEmail }}</span>
                </div>
              }

              <!-- Sender Phone Number -->
              @if (connectionData.SenderPhoneNumber) {
                <div class=" mb-1">
                  <i class="fa fa-phone text-muted"></i>
                  <span class="ms-1  fw-bold">{{ 'connectionRequest.phoneNumber' | transloco }}</span>
                  <span class="ms-1">{{ connectionData.SenderPhoneNumber }}</span>
                </div>
              }

              <!-- Sender Address -->
              @if (connectionData.SenderAddressLine1 || connectionData.SenderAddressLine2) {
                <div
                  class=" mb-1">
                  <i class="fa fa-map-marker text-muted"></i>
                  <span class="ms-1  fw-bold">{{ 'connectionRequest.address' | transloco }}</span>
                  <span class="ms-1">{{ connectionData.SenderAddressLine1 }}</span>
                  @if (connectionData.SenderAddressLine2) {
                    <span class="ms-1">| {{
                    connectionData.SenderAddressLine2 }}</span>
                  }
                </div>
              }

              <!-- Request Sent Date -->
              @if (connectionData.RequestSentDate) {
                <div class=" mb-1">
                  <i class="fa fa-calendar text-muted"></i>
                  <span class="ms-1  fw-bold">{{ 'connectionRequest.requested' | transloco }}</span>
                  <span class="ms-1">{{ connectionData.RequestSentDate | date: 'mediumDate' }}</span>
                </div>
              }
            </div>



          </div>
          <!-- About Me Section -->
          @if (connectionData.SenderAboutMe) {
            <div class="mt-2">
              <div [innerHTML]="connectionData.SenderAboutMe">
              </div>
            </div>
          }
        </div>
      </div>






      <div class="row border my-3">

        <p-tabView [(activeIndex)]="selectedTabIndex">
          <!-- Current Inventory -->
          <p-tabPanel [header]="'connectionRequest.currentInventory' | transloco">
            <!-- Current Inventory title -->
            <div class="col-12 mt-2">
              @if (connectionData.SenderNewProductsAdded) {
                <div class="row">
                  @for (product of connectionData.SenderNewProductsAdded; track product) {
                    <div class="col-4 mb-2">
                      <!-- Display current inventory -->
                      <div class="custom-product-container border ">
                        <div class="custom-img-container">
                          <img [src]="product.ProductImageUrl? product.ProductImageUrl : 'assets/images/No-Image.png'"
                            class="custom-img rounded-cube border" [alt]="'connectionRequest.productImage' | transloco">
                          </div>
                          <div class="d-flex flex-column w-100 p-2 ellipsis" title="{{product.ProductName}}">
                            <div class="text-uppercase fw-semibold ellipsis">{{product.ProductName}}</div>
                            <div class="d-flex flex-column small mt-2">
                              <!-- ArtType -->
                              @if (product.ArtTypeName) {
                                <div class="d-flex align-items-center">
                                  <div class="text-uppercase fw-semibold">{{ 'connectionRequest.artType' | transloco }}</div>
                                  <div class="ms-1">{{product.ArtTypeName}}</div>
                                </div>
                              }
                              <!-- Accepted Date -->
                              @if (product.AcceptedDate) {
                                <div class="d-flex align-items-center">
                                  <div class="text-uppercase fw-semibold">{{ 'connectionRequest.accepted' | transloco }}</div>
                                  <div class="ms-1">{{product.AcceptedDate | date:
                                    'dd/MM/yyyy'}}@if (product.AcceptedDaysAgo) {
                                    {{ 'connectionRequest.daysAgo' | transloco: { days: product.AcceptedDaysAgo } }}
                                  }</div>
                                </div>
                              }
                              @if (product.ArtistRevenue) {
                                <div class="d-flex align-items-center">
                                  <div class="text-uppercase fw-semibold">{{ 'connectionRequest.price' | transloco }}</div>
                                  <div class="ms-1">{{product.ArtistRevenue |
                                    currency:'USD':'symbol':'1.2-2'}}
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- Display "Not Found" message if current inventory data is not available -->
                @if (!(connectionData.SenderNewProductsAdded) || (connectionData.SenderNewProductsAdded.length === 0)) {
                  <div class="row my-2"
                    >
                    <div class="col-6 text-left">
                      {{ 'connectionRequest.noDataAvailable' | transloco }}
                    </div>
                  </div>
                }
              </div>
            </p-tabPanel>
            <!-- Tab Content for "User Information" -->
            <p-tabPanel [header]="'connectionRequest.recentSales' | transloco">
              <!-- Recent Sales title -->
              <div class="col-12 border-end mt-2">
                @if (connectionData.SenderRecentSales) {
                  <div class="row">
                    @for (product of connectionData?.SenderRecentSales; track product) {
                      <div class="col-4 mb-2">
                        <!-- Display recent sales -->
                        <div class="custom-product-container border">
                          <div class="custom-img-container">
                            <img [src]="product.ProductImageUrl ? product.ProductImageUrl : 'assets/images/No-Image.png'"
                              class="custom-img rounded-cube border" [alt]="'connectionRequest.productImage' | transloco">
                            </div>
                            <div class="d-flex flex-column w-100 p-2" title="{{product.ProductName}}">
                              <div class="text-uppercase fw-bold ellipsis small">{{product.ProductName}}</div>
                              <div class="d-flex flex-column small mt-2">
                                <!-- Art Type -->
                                @if (product.ArtTypeName) {
                                  <div class="d-flex align-items-center">
                                    <div class="fw-semibold text-uppercase">{{ 'connectionRequest.artType' | transloco }}</div>
                                    <div class="ms-1">{{product.ArtTypeName}}</div>
                                  </div>
                                }
                                @if (product.SoldPrice) {
                                  <div class="d-flex align-items-center ">
                                    <div class=" fw-semibold text-uppercase">{{ 'connectionRequest.sold' | transloco }}</div>
                                    <div class="ms-1">{{product.SoldPrice |
                                    currency:'USD':'symbol':'1.2-2'}}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <!-- Display "Not Found" message if recent sales data is not available -->
                  @if (!(connectionData.SenderRecentSales) || (connectionData.SenderRecentSales.length === 0)) {
                    <div class="row my-2"
                      >
                      <div class="col-6 text-left">
                        {{ 'connectionRequest.noDataAvailable' | transloco }}
                      </div>
                    </div>
                  }
                </div>
              </p-tabPanel>
            </p-tabView>
          </div>
          @if (connectionData?.IsInitiatedByArtist) {
            <div class="row border p-3">
              <!-- Left Column -->
              <div class="col-6 border-end pe-4">
                <div class="key-performance-metrics">
                  <div class="fw-bold mb-4 h4">{{ 'connectionRequest.keyPerformanceMetrics' | transloco }}</div>
                  @if (connectionData?.ArtistKeyStats?.ArtistArtTypes) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.artistArtTypes' | transloco }}</span>
                      <div class="d-flex flex-wrap gap-2 mt-2">
                        @for (artType of connectionData.ArtistKeyStats?.ArtistArtTypes; track artType) {
                          <span class="badge text-bg-secondary p-2">{{ artType }}</span>
                        }
                      </div>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.NoOfConsignmentsDispatched) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.noOfConsignmentsDispatched' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.NoOfConsignmentsDispatched }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.NoOfDispatchedProducts) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.noOfDispatchedProducts' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.NoOfDispatchedProducts }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.AverageRetailPrice) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.averageRetailPrice' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.AverageRetailPrice |
                      currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.AverageTurnoverRate) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.averageTurnoverRate' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.AverageTurnoverRate |
                      currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.NoOfSoldProducts) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.noOfSoldProducts' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.NoOfSoldProducts }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.AverageSalesValuePerProduct) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.averageSalesValuePerProduct' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.AverageSalesValuePerProduct |
                      currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                  @if (connectionData?.ArtistKeyStats?.TotalSalesValue) {
                    <div class="mb-3">
                      <span class="fw-bold">{{ 'connectionRequest.totalSalesValue' | transloco }}</span>
                      <span class="ms-2">{{ connectionData.ArtistKeyStats?.TotalSalesValue |
                      currency:'USD':'symbol':'1.2-2' }}</span>
                    </div>
                  }
                </div>
              </div>
              <!-- Right Column -->
              <div class="col-6 ps-4">
                @if (connectionData.SenderResume) {
                  <div class="mt-2">
                    <div [innerHTML]="connectionData.SenderResume"></div>
                  </div>
                }
              </div>
            </div>
          }


        </div>
      </div>

      <p-dialog [header]="'connectionRequest.acceptConnectionRequest' | transloco" [(visible)]="showCommentDialog" [modal]="true"
        [style]="{'width': '530px' }">
        <form class="form-horizontal mt-2 px-3">
          <div class="text-muted small">
            <i class="fa fa-info-circle me-1"></i> {{ 'connectionRequest.addCommentsAccept' | transloco }}
          </div>
          <div class="form-group my-3">
            <div class="panel-container">
              <div class="panel-body position-relative">
                <textarea id="comments" pInputTextarea rows="3" name="comments"
                  [(ngModel)]="formData.InviteAcceptanceComment"
                  [placeholder]="'connectionRequest.addCommentAcceptPlaceholder' | transloco" class="form-control">
                </textarea>
                <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog('Accept')"
                  style="top: 50%; right: 0.5rem; transform: translateY(-50%);">
                  (😍)
                </div>
                <button pButton type="button" class="p-button-outlined w-100 mt-2" [label]="'connectionRequest.acceptRequest' | transloco"
                  (click)="confirmInvite()">
                </button>
              </div>
            </div>
          </div>
        </form>
      </p-dialog>

      <p-dialog [header]="'connectionRequest.declineConnectionRequest' | transloco" [(visible)]="showRejectCommentDialog" [modal]="true"
        [style]="{'width': '530px' }" (onHide)="closeRejectDialog()">
        <form class="form-horizontal mt-2 px-3">
          <div class="text-muted small">
            <i class="fa fa-info-circle me-1"></i> {{ 'connectionRequest.addCommentsReject' | transloco }}
          </div>
          <div class="form-group my-3">
            <div class="panel-container">
              <div class="panel-body position-relative">
                <textarea id="comments" pInputTextarea rows="3" name="comments"
                  [(ngModel)]="formData.InviteRejectionComment" [placeholder]="'connectionRequest.addComment' | transloco"
                  class="form-control">
                </textarea>
                <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog('Reject')"
                  style="top: 50%; right: 0.5rem; transform: translateY(-50%);">
                  (😍)
                </div>
                <button pButton type="button" class="p-button-outlined w-100 mt-2" [label]="'connectionRequest.declineRequest' | transloco"
                  (click)="rejectInvitation()">
                </button>
              </div>
            </div>
          </div>
        </form>
      </p-dialog>

      <!-- Emoji-Dialog -->
      @if (displayEmojiDialog) {
        <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
        (emojiClick)="addEmoji($event)"></app-emoji-list>
      }